export const EHubEditMutations = [
    'GET_HUB_INFO',
    'RESET_HUB_INFO',
];
// eslint-disable-next-line no-shadow
